export let Store = [];

export let Weights = [];

export let Flow = {
  'completed' : [],
  'desired' : []
};


// WEBPACK FOOTER //
// ./src/Store.js